import React from "react";
import { Api } from "../app-controller.js";
import Swal from "sweetalert2";
import PrescriptionSupply from "../components/prescription/PrescriptionSupply";

class MoveProducts extends React.Component {
  initialState = {
    establecimientos: [],
    establecimiento: "",
    producto_valido: false,
    receta_valida: false,
    receta: "",
    cantidad_lote: { cantidad: "", lote: "" },
    folio_receta: "",
    producto_sgi: "",
    cantidad_agregada_validada: [],
    cantidades_lotes: [],
    cantidad_receta: "",
    nivelUsuario: localStorage.nivel_actual,
    establecimiento_recibe: "",
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (!["1"].includes(this.state.nivelUsuario)) {
      window.location.href = "/";
    }

    // fn para obtener el establecimiento con actividad farmacia del regente con profesión de médico veteirnario
    this.getEstablishmentFarmaciaMedVet();
  }

  /********* LLAMADAS A LA API ***********/

  getEstablishmentFarmaciaMedVet = () => {
    Api.loading(true);
    Api.fetch("app/getEstablishmentFarmaciaMedVet")
      .then((data) => {
        if (data) {
          this.setState({ establecimientos: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  /********** FUNCIONES PARA CONTROLAR EVENTOS **********/

  handleRazonSocialChange = (evt) => {
    if (evt.target.name === "razon_social") {
      // Asignamos el valor a establecimiento
      this.setState({
        razon_social: evt.target.value.toUpperCase(),
      });

      // limpamos errores si es que los hay
      this.cleanErrorsValidation("razon_social");
    }

    if (evt.target.name === "guid") {
      // Asignamos el valor a establecimiento
      this.setState({
        guid: evt.target.value.toUpperCase(),
      });

      // limpamos errores si es que los hay
      this.cleanErrorsValidation("guid");
    }
  };

  handleFolioRecetaChange = (evt) => {
    this.resetPrescriptionData();
    this.cleanErrorsValidation("folio_receta");
    this.setState({
      folio_receta: evt.target.value.toUpperCase(),
      receta_valida: false,
    });
  };

  handleGuidEstablecimiento = (evt) => {
    evt.preventDefault();
    let razonSocial = this.state.razon_social,
      guid = this.state.guid,
      establecimiento = { razon_social: "", guid: "", actividad_id: "" },
      actividad = this.state.actividad,
      actividad_msg = "";

    if (!razonSocial) {
      this.handleValidations("razon_social", true);
    }

    if (!guid) {
      this.handleValidations("guid", true);
    }

    if (!actividad) {
      this.handleValidations("actividad", true);
    }

    if (guid && razonSocial && actividad) {
      let actividad_id = "";
      switch (actividad.id) {
        case "1": // almacenador
          actividad_id = "2"; // distribuidor
          actividad_msg = "DISTRIBUIDOR";
          break;
        case "2": // distribuidor
          actividad_id = "16"; // farmacia
          actividad_msg = "FARMACIA";
          break;
        case "16": // farmacia
          actividad_id = "16"; // farmacia
          actividad_msg = "FARMACIA";
          break;
        case "18": // importador
          actividad_id = "1"; // almacenador
          actividad_msg = "ALMACENADOR";
          break;

        default:
          break;
      }

      establecimiento.razon_social = razonSocial;
      establecimiento.guid = guid;
      establecimiento.actividad_id = actividad_id;

      Api.loading(true);
      Api.fetch(
        "app/getValidGUIDEstablishmentProductMovements",
        establecimiento,
        "POST"
      ).then((data) => {
        Api.loading(false);
        if (Object.keys(data).length > 0) {
          Swal.fire({
            icon: "success",
            title: "¡Establecimiento encontrado!",
            text: "Se ha encontrado establecimiento.",
            timer: "3000",
            confirmButtonText: "Regresar",
          });

          this.setState({
            establecimiento_recibe: data,
            actividad_recibe_id: actividad_id,
            guidValidado: true,
          });
          document
            .getElementById("razon_social")
            .setAttribute("readonly", true);
          document.getElementById("guid").setAttribute("readonly", true);
          document.getElementById("guidBtn").classList =
            "btn btn-success btn-block";
          document.querySelector("#guidBtn i").classList = "fas fa-check";
        } else {
          Swal.fire({
            icon: "warning",
            title: "¡Establecimiento no encontrado!",
            text: `Debe ingresar razón social con actividad ${actividad_msg} y licencia activa.`,
            // timer: "3000",
            confirmButtonText: "Regresar",
          });
        }
      });
    }
  };

  verifyFolioReceta = (evt) => {
    evt.preventDefault();

    let folioReceta = this.state.folio_receta;

    if (!folioReceta) {
      this.validateSingleError("folio_receta", "Ingrese folio de receta.");
    }

    if (folioReceta) {
      Api.loading(true);

      Api.fetch("app/verifyFolioReceta?folio_receta=" + folioReceta).then(
        (data) => {
          if (data) {
            if (Object.keys(data).length === 0) {
              this.fireSwal(
                "¡Receta no encontrada!",
                "warning",
                "No se encontró con receta con el folio " + folioReceta
              );

              this.setState({
                receta_valida: false,
              });
            } else if (data.surtida) {
              this.fireSwal(
                "¡Receta ya surtida!",
                "warning",
                "La receta con folio " + folioReceta + " ya ha sido surtida"
              );

              this.setState({
                receta_valida: false,
              });
            } else if (data.no_vencida === "0") {
              this.fireSwal(
                "¡Receta Vencida!",
                "warning",
                "La receta con folio " +
                  folioReceta +
                  ", expedida el " +
                  data.fec_expedicion +
                  " ha expedido el " +
                  data.fec_vencimiento
              );

              this.setState({
                receta_valida: false,
              });
            } else {
              this.fireSwal(
                "¡Receta encontrada!",
                "success",
                "Se ha encontrado receta con el folio " + folioReceta
              );

              this.setState({
                receta_valida: true,
                receta: data,
                cantidad_receta: data.cant_num,
              });
            }
          }
        }
      );
    }
  };

  removeCantidadLote = (evt) => {
    let cantidadesLotes = [...this.state.cantidades_lotes],
      cantidadAgregadaValidada = [...this.state.cantidad_agregada_validada],
      cantidadReceta = parseInt(this.state.cantidad_receta);

    cantidadReceta += parseInt(cantidadesLotes[evt.target.id].cantidad);

    cantidadesLotes.splice(evt.target.id, 1);
    cantidadAgregadaValidada.splice(evt.target.id, 1);

    this.cleanErrorsValidation("lote");
    this.cleanErrorsValidation("cantidad");

    this.setState({
      cantidades_lotes: cantidadesLotes,
      cantidad_agregada_validada: cantidadAgregadaValidada,
      cantidad_receta: cantidadReceta,
    });
  };

  verifyProduct = (evt) => {
    evt.preventDefault();

    let cantidadLote = { ...this.state.cantidad_lote },
      establecimiento = this.state.establecimiento,
      receta = this.state.receta,
      producto_valido = this.initialState.producto_valido;

    if (!cantidadLote.lote) {
      this.validateSingleError("lote", "Ingrese lote.");
    }

    if (cantidadLote.lote) {
      Api.loading(true);

      Api.fetch(
        "app/verifyProduct?lote=" +
          cantidadLote.lote +
          "&producto_id=" +
          receta.producto_id +
          "&presentacion_id=" +
          receta.producto_presentacion_id +
          "&establecimiento_id=" +
          establecimiento.id +
          "&actividad_id=" +
          establecimiento.establecimiento_actividad_id
      ).then((data) => {
        if (data && Object.keys(data).length > 0) {
          Swal.fire({
            icon: "success",
            title: "¡Producto encontrado!",
            text: "Se ha encontrado producto especificaciones ingresadas",
            confirmButtonText: "Regresar",
            timer: 5000,
          });

          producto_valido = true;

          this.setState({
            producto_valido: producto_valido,
            producto_sgi: data,
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "¡Producto no encontrado!",
            text: "No se encontró producto con las especificaciones ingresadas",
            confirmButtonText: "Regresar",
            timer: 5000,
          });
        }
      });
    }
  };

  validateSingleError = (el, msg) => {
    if (el && this.state.producto_valido) {
      document.getElementById(el + "-error").style.display = "block";
      document.getElementById(el + "-error").innerText = msg;
      document.getElementById(el).classList.add("is-invalid");
    }
  };

  handleSubmit = (evt) => {
    evt.preventDefault();

    let prescriptionSupplyData = { ...this.state };

    delete prescriptionSupplyData.cat_establecimiento;

    if (!prescriptionSupplyData.folio_receta) {
      this.validateSingleError("folio_receta", "Ingrese folio de receta");
      return false;
    }

    if (
      !prescriptionSupplyData.cantidad_lote.lote &&
      this.state.receta_valida
    ) {
      this.validateSingleError("lote", "Ingrese lote.");
      return false;
    }
    if (
      prescriptionSupplyData.cantidad_lote.lote &&
      !prescriptionSupplyData.cantidad_lote.cantidad
    ) {
      this.validateSingleError("cantidad", "Ingrese cantidad.");
      return false;
    }

    // sumar cantidades ingresadas válidas
    let cantidadIngresadaTotal =
      prescriptionSupplyData.cantidad_agregada_validada.reduce(
        (acc, curr) => acc + curr.cantidad_solicitada,
        0
      );

    if (prescriptionSupplyData.cantidad_agregada_validada.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "¡Atención!",
        text: "Debe ingresar lote y cantidad para surtir receta",
        confirmButtonColor: "#0275d8",
        confirmButtonText: `Regresar`,
      });
    } else if (cantidadIngresadaTotal < this.state.receta.cant_num) {
      Swal.fire({
        icon: "warning",
        title: "¡Atención!",
        text: "La cantidad ingresada no satisface la cantidad recetada",
        confirmButtonColor: "#0275d8",
        confirmButtonText: `Regresar`,
      });
    } else {
      Swal.fire({
        icon: "question",
        title: "¿Completar transacción?",
        text: "¡Asegúrese que los datos estén completados correctamente!",
        showDenyButton: true,
        denyButtonColor: "red",
        confirmButtonColor: "#4CD964",
        showCancelButton: false,
        confirmButtonText: `Continuar`,
        denyButtonText: `Regresar`,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.submitForm(prescriptionSupplyData);
        }
      });
    }
  };

  submitForm = (prescriptionSupplyData) => {
    Api.loading(true);
    Api.fetch("app/supplyPrescription", prescriptionSupplyData, "POST").then(
      (data) => {
        if (data.errors) {
          this.handleValidations(data.errors);
          Api.loading(false);
          this.fireSwal(
            "¡Verifique que los datos esten correctamente completados!",
            "warning"
          );
          return false;
        } else {
          Api.loading(false);
          Swal.fire({
            icon: "success",
            title: "¡La receta ha sido surtida exitosamente!",
            confirmButtonText: "Continuar",
            timer: 3000,
          }).then(() => {
            window.location.href = "/recetas-electronicas/surtidas";
          });
          this.resetStates();
        }
      }
    );
  };

  handleEstablecimientoChange = (obj) => {
    this.setState({ establecimiento: obj, receta_valida: false });
    this.resetPrescriptionData();
  };

  resetPrescriptionData = () => {
    this.setState({
      receta: this.initialState.receta,
      cantidad_lote: this.initialState.cantidad_lote,
      producto_valido: this.initialState.producto_valido,
      cantidades_lotes: this.initialState.cantidades_lotes,
    });
  };

  // fn para marcar los campos que duevelen error desde la api
  handleValidations = (errors, guidValidation = false) => {
    if (guidValidation) {
      let msg = "";
      switch (errors) {
        case "razon_social":
          msg =
            "Debe ingresar la razón social para poder realizar la verificación GUID.";
          break;
        case "guid":
          msg = "Debe ingresar GUID para poder realizar la verificación GUID.";
          break;
        case "actividad":
          msg =
            "Debe Seleccionar actividad para poder realizar la verificación GUID.";
          break;

        default:
          break;
      }

      document.getElementById(errors + "-error").style.display = "block";
      document.getElementById(errors + "-error").innerText = msg;
      document.getElementById(errors).classList.add("is-invalid");
    } else {
      for (const i in errors) {
        document.getElementById(i + "-error").style.display = "block";
        document.getElementById(i + "-error").innerText = errors[i];
        document.getElementById(i).classList.add("is-invalid");
      }
    }
  };

  // fn para depslegar mensajes de alerta sencillos
  fireSwal(title, icon = "error", text = "") {
    Swal.fire({
      title: title,
      icon: icon,
      text: text,
      timer: 7000,
      confirmButtonText: "Regresar",
    });
    return false;
  }

  // fn para reiniciar todos los estados una vez el submit sea éxitoso
  resetStates = () => {
    // this.setState({
    //   actividad: this.initialState.actividad,
    // });
  };

  /*********** Funciones ***********/

  // funcion para validar sólo enteros positivos en un input
  checkPositiveIntegers = (str) => {
    let regex = /^[1-9]\d*$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }

    return response;
  };

  handleCantidadLote = (evt) => {
    let inputName = evt.target.name,
      inputValue = evt.target.value,
      cantidadLote = { ...this.state.cantidad_lote },
      producto_valido = this.state.producto_valido,
      productoSGI = { ...this.state.producto_sgi },
      receta = { ...this.state.receta },
      cantidadReceta = this.state.cantidad_receta;

    if (inputName === "cantidad") {
      if (this.checkPositiveIntegers(inputValue)) {
        // limpamos errores si es que los hay
        this.cleanErrorsValidation(inputName);
        cantidadLote.cantidad = inputValue;

        if (parseInt(inputValue) > parseInt(productoSGI.cantidad)) {
          this.validateSingleError(
            inputName,
            `Este lote sólo cuenta con ${productoSGI.cantidad} existencias.`
          );
        } else if (parseInt(inputValue) > parseInt(cantidadReceta)) {
          this.validateSingleError(
            inputName,
            `La cantidad recetada indica sólo ${receta.cant_num} unidades.`
          );
        } else {
          // limpamos errores si es que los hay
          this.cleanErrorsValidation("cantidad");
        }
        this.setState({ cantidad_lote: cantidadLote });
      }
    }

    if (inputName === "lote") {
      // limpamos errores si es que los hay
      this.cleanErrorsValidation(inputName);
      cantidadLote.lote = inputValue.toUpperCase();

      if (producto_valido) {
        cantidadLote.cantidad = "";
      }

      this.setState({
        cantidad_lote: cantidadLote,
        producto_valido: this.initialState.producto_valido,
        producto_sgi: this.initialState.producto_sgi,
      });
    }
  };

  addCantidadLote = (evt) => {
    evt.preventDefault();

    let cantidadLote = { ...this.state.cantidad_lote },
      cantidadesLotes = [...this.state.cantidades_lotes],
      productoSGI = { ...this.state.producto_sgi },
      cantidadAgregadaValidada = [...this.state.cantidad_agregada_validada],
      receta = { ...this.state.receta };

    if (!cantidadLote.cantidad) {
      this.validateSingleError("cantidad", "Ingrese cantidad.");
    }

    if (cantidadLote.cantidad === 0) {
      this.validateSingleError("cantidad", "La cantidad debe ser mayor a 0.");
    }

    if (!cantidadLote.lote) {
      this.validateSingleError("lote", "Ingrese lote.");
    }

    if (cantidadLote.cantidad && cantidadLote.lote) {
      // validamos que el lote a ingresar no se encuentra en la lista de lotes ya listados
      if (cantidadesLotes.find((obj) => obj.lote === cantidadLote.lote)) {
        Swal.fire({
          icon: "warning",
          title: "¡Atención!",
          text: `El lote ${cantidadLote.lote} ya se encuentra listado`,
          timer: 5000,
        });
        this.validateSingleError("lote", "Lote ya listado.");
      } else {
        // calculamos cantidad de cgi con las que se quieren ingresar
        let cantidadLoteInt = parseInt(cantidadLote.cantidad),
          cantidadSGI = parseInt(productoSGI.cantidad),
          cantidadReceta = parseInt(receta.cant_num),
          cantidadRestanteSGI = 0,
          cantidadRestantreReceta = 0,
          cantidadRC = parseInt(this.state.cantidad_receta);

        if (cantidadSGI === 0) {
          Swal.fire({
            icon: "warning",
            title: "¡Atención!",
            text: `El lote ${cantidadLote.lote} cuenta con 0 existencias actualmente.`,
            timer: 5000,
          });
        } else {
          cantidadRestanteSGI = cantidadSGI - cantidadLoteInt;
          cantidadRestantreReceta = cantidadRC - cantidadLoteInt;

          if (cantidadRestanteSGI < 0) {
            Swal.fire({
              icon: "warning",
              title: "¡Atención!",
              text: `El lote ${cantidadLote.lote} sólo cuenta con ${cantidadSGI} existencias actualmente.`,
              confirmButtonText: "Regresar",
              timer: 5000,
            });
          } else if (cantidadRestantreReceta < 0) {
            Swal.fire({
              icon: "warning",
              title: "¡Atención!",
              text: `La cantidad recetada indica sólo ${cantidadReceta} unidades.`,
              confirmButtonText: "Regresar",
              timer: 5000,
            });
          } else {
            productoSGI.cantidad = cantidadRestanteSGI;

            productoSGI["cantidad_solicitada"] = cantidadLoteInt;
            cantidadLote["fecha_fabricacion"] = productoSGI.fecha_fabricacion
              .substr(0, 10)
              .split("-")
              .reverse()
              .join("/");
            cantidadLote["vencimiento_lote"] = productoSGI.vencimiento_lote
              .substr(0, 10)
              .split("-")
              .reverse()
              .join("/");

            cantidadesLotes.push(cantidadLote);
            cantidadAgregadaValidada.push(productoSGI);

            this.cleanErrorsValidation("lote");
            this.cleanErrorsValidation("cantidad");

            this.setState({
              cantidades_lotes: cantidadesLotes,
              cantidad_receta: cantidadRestantreReceta,
              // cantidad_lote: this.initialState.cantidad_lote,
              // producto_sgi: this.initialState.productoSGI,
              cantidad_agregada_validada: cantidadAgregadaValidada,
            });
          }
        }
      }
    }
  };

  // fn para limpar errores cuando cambie el estado del input que los tenga
  cleanErrorsValidation = (elemento) => {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (divError && classInvalid) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  };

  render() {
    return (
      <PrescriptionSupply
        state={this.state}
        handleFolioRecetaChange={this.handleFolioRecetaChange}
        verifyFolioReceta={this.verifyFolioReceta}
        verifyProduct={this.verifyProduct}
        handleCantidadLote={this.handleCantidadLote}
        addCantidadLote={this.addCantidadLote}
        handleSubmit={this.handleSubmit}
        removeCantidadLote={this.removeCantidadLote}
        handleEstablecimientoChange={this.handleEstablecimientoChange}
      />
    );
  }
}

export default MoveProducts;
